<template>
  <div class="ml_order_list">
    <div class="ml_order_item" v-for="(item, index) in list" :key="index" @click="goToDetail(item)">
      <div class="ml_order_item_content">
        <div class="ml_order_item_content_header" style="padding-bottom: 30rpx;">
          <div class="ml_order_item_carname">
            {{ item.vehicleName }}
          </div>
          <!-- 拍卖状态(1:待入场,2：拍卖结束(流拍),3:发拍失败,4:交易成功,5结标中,6:已入场,7:中标) -->
          <template v-if="item.auctionStatus == 3">
            <div class="ml_auction_status_end">
              {{ item.auctionStatusName }}
            </div>
          </template>
          <template v-else>
            <div class="ml_auction_status">
              {{ item.auctionStatusName }}
            </div>
          </template>
        </div>
        <div class="ml_car_info">
          <div class="ml_order_item_img">
            <img v-if="item.firstImage" :src="item.firstImage + '?x-oss-process=image/resize,w_640,h_480/quality,q_90'"
              mode="aspectFill" class="ml_order_item_img_icon" />
          </div>
          <div class="ml_car_info_right">
            <div class="ml_car_card_base" style="padding-top: 5px;">
              <div class="ml_car_card_base_item">
                <span selectable user-select>{{ item.plate || "-" }}</span>
              </div>
              <span style="color: #E9E9E9;">|</span>
              
              <div class="ml_car_card_base_item">
                {{ item.registrationDate || "-" }}
              </div>
              <span style="color: #E9E9E9;">|</span>
              
              <div class="ml_car_card_base_item">
                <template v-if="item.drivenDistance">
                  {{ item.drivenDistance }}公里
                </template>
                <template v-else>-</template>
              </div>
            </div>
            <div class="ml_car_card_base">
              车辆编号：<span>{{ item.vehicleCode || "-" }}</span>
            </div>
            <div>
              <div class="ml_flex ml_flex_center">
                <div class="ml_flex_item">
                  <span class="ml_car_price ml_price_value_font">{{item.startingPrice||'-'}}</span>
                  <span class="ml_car_price_unit">万起拍价</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ml_order_item_footer">
        <div>
          {{ item.storeName || "-" }}
        </div>
        <div class="ml_order_item_footer_item">
          <span class="ml_car_card_base_item">
            发拍：{{ item.sendTime || "-" }}
          </span>
          <span class="ml_car_card_base_item">
            {{ item.sendUserName || "-" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {

    }
  },
  props: {
    list: {
      type: Array,
      value: []
    },
    sid:{
      type:String,
      value:''
    }
  },
  methods: {
    goToDetail(e) {
      // 跳转到详情
      const that = this
      that.$router.push({
        path:'/auctiondetail',
        query:{
          id:e.id,
          sid:that.sid
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ml_order_list {
  padding: 0 10px;

  .ml_order_item {
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 8px;
    background-color: #FFFFFF;

    &:last-child {
      margin: 0;
    }

    .ml_order_item_content {
      padding-bottom: 10px;
      .ml_order_item_content_header{
        display: flex;
        padding-bottom: 10px;
        .ml_order_item_carname {
          flex: 1;
          color: #332D29;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
        }
        .ml_auction_status {
          font-size: 12px;
          color: #327FFF;
          padding-left: 10px;
          text-align: right;
        }

        .ml_auction_status_end {
          font-size: 12px;
          color: #FF0000;
          padding-left: 10px;
          text-align: right;
        }
      }
      .ml_car_info{
        display: flex;
        .ml_order_item_img {
          width: 92px;
          height: 69px;
          position: relative;
          margin-right: 10px;
          background: url('../assets/56.png') no-repeat center center;
          background-size: 100% 100%;
          border-radius: 8px;

          .ml_order_item_img_icon {
            height: 100%;
            width: 100%;
            border-radius: 8px;
            display: block;
          }
        }
        .ml_car_info_right{
          .ml_car_card_base {
            font-size: 12px;
            padding-bottom: 5px;
            color: #979797;
            display: flex;
            line-height: 14px;
            .ml_car_card_base_item{
              padding: 0 8px;
              position: relative;
              display: inline-block;
              vertical-align: middle;
              line-height: 16px;
              &:first-child{
                padding-left: 0;
              }
            }
          }
        }
      }
    }

    .ml_order_item_footer {
      display: flex;
      font-size: 12px;
      color: #666666;
      .ml_order_item_footer_item{
        flex: 1;
        text-align: right;
      }
    }
  }

  .ml_car_price {
    color: #FF6600;
    font-weight: bold;
    font-size: 16px;
  }

  .ml_car_price_unit {
    color: #FF6600;;
    font-size: 12px;
  }
}
</style>